<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <h2>{{ $t("vehicle.title") }}</h2>
    <b-row v-if="hasLimit">
      <b-col cols="3">
        <label for="message"
          >Veículos cadastrados: {{ totalVehicleRegistered }} /
          {{ totalVehicles }}
        </label>
      </b-col>
      <b-col v-if="!canCreate">
        <label for="messageContact" class="alertMessage"
          >Sua franquia permite o cadastro de até {{ totalVehicles }} veículos.
          Para aumentar o limite, favor entrar em contato com nosso suporte.
        </label>
      </b-col>
    </b-row>

    <b-row>
      <router-link
        v-bind:class="{ 'disabled-link': !canCreate }"
        :to="canCreate ? '././create' : '#'"
      >
        <b-button :disabled="!canCreate" size="sm">{{
          $t("geral.create")
        }}</b-button>
      </router-link>
      <b-col cols="0" class="ml-2">
        <router-link
          :class="{ 'disabled-link': !canCreate }"
          :to="canCreate ? '././import' : '#'"
        >
          <b-button :disabled="!canCreate" size="sm">
            {{ $t("geral.import") }}
          </b-button>
        </router-link>
      </b-col>
      <b-col cols="0" class="ml-2">
        <b-button size="sm" @click="downloadLayout">
          {{ $t("geral.importLayout") }}
        </b-button>
      </b-col>
      <b-col v-if="userRms">
        <b-button size="sm" @click="$refs.configVehicleModal.open()">
          Configurador
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.filterKey != 'actions'">
                <b-form-input
                  v-if="field.filterKey == 'documentExpiration'"
                  class="dateCreate"
                  type="date"
                  v-model="tableFilters[field.filterKey]"
                />
                <multiselect
                  v-else-if="field.filterKey == 'typeName'"
                  v-model="tableFilters[field.filterKey]"
                  class="vehicleType"
                  label="text"
                  track-by="value"
                  :close-on-select="false"
                  :showLabels="false"
                  :placeholder="'Buscar por tipo'"
                  :options="vehicleTypeOpt"
                  :multiple="true"
                ></multiselect>
                <b-form-select
                  v-else-if="field.filterKey == 'active'"
                  v-model="tableFilters[field.filterKey]"
                  id="perPageSelect"
                  :options="activeOpt"
                ></b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <router-link :to="`././edit/${data.item.id}`">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>

          <b-button
            size="sm"
            class="btn-checklist ml-2"
            v-b-modal.modalVehicle
            @click="getVehicleData(data.item.id, data.item.active)"
          >
            {{
              data.item.active ? $t("geral.deactivate") : $t("geral.activate")
            }}
          </b-button>
        </template>
      </b-table>
    </b-row>
    <ConfigSaveVahicleModal ref="configVehicleModal"></ConfigSaveVahicleModal>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>

    <vehicle-available-reason-modal
      :vehicleId="vehicleId"
      :isActivate="vehicleActive"
      :vehicleAvailable="vehicleAvailable"
      :totalVehicleRegistered="totalVehicleRegistered"
      :totalVehicles="totalVehicles"
      @refreshTable="updateTableMethod"
    />
  </b-container>
</template>
<script>
export default {
  name: "VehicleList",
  components: {
    "vehicle-available-reason-modal": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReasonModal.vue"
      ),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ConfigSaveVahicleModal: () =>
      import("@/components_rms/vehicle/ConfigSaveVehicleModal.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Equipamento cadastrado com sucesso",
      },

      vehicleId: null,
      vehicleActive: null,
      vehicleAvailable: null,

      totalVehicles: 0,
      totalVehicleRegistered: 0,
      hasConfig: false,
      hasLimit: false,
      canCreate: false,

      isBusy: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "id",
          filterKey: "id",
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "plate",
          filterKey: "plate",
          label: "Placa",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "vehicleModel",
          filterKey: "vehicleModel",
          label: "Modelo",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "vehicleBrand",
          filterKey: "vehicleBrand",
          label: "Marca",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "typeName",
          filterKey: "typeName",
          label: "Tipo do Equipamento",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "documentExpiration",
          filterKey: "documentExpiration",
          label: "Vencimento Doc.",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        id: "",
        active: "true",
        plate: "",
        typeName: [],
        documentExpiration: "",
      },
      vehicleTypeOpt: [],
      activeOpt: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],

      userRms: false,
    };
  },
  created() {
    this.getAllVehicleType();
    this.getDetails();
    this.isRmsUser();
  },
  methods: {
    getDetails() {
      this.$apiVehicle.get("/vehicle/getDetails/").then((response) => {
        if (response.data == "") {
          this.canCreate = true;
        } else {
          this.totalVehicles = response.data.totalVehicle;
          this.totalVehicleRegistered = response.data.totalVehicleRegistration;
          this.hasConfig = response.data.hasConfig;
          this.hasLimit = true;
          if (this.totalVehicleRegistered < this.totalVehicles)
            this.canCreate = true;
          else if (this.hasConfig) {
            this.canCreate = true;
          }
        }
      });
    },
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    updateTableMethod() {
      this.$refs.table.refresh();
      this.getDetails();
    },
    getVehicleData(vehicleId, vehicleActive) {
      this.vehicleId = vehicleId;
      this.vehicleActive = vehicleActive;
      // console.log(vehicleId + " " + vehicleActive + " " + reasonId);
    },
    getUrlEdit(vehicle) {
      return `././edit/${vehicle.id}`;
    },
    downloadLayout() {
      this.$apiVehicle
        .request({
          url: `/vehicle/import/download/`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$refs.openModal.hide();
        });
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: ctx.filter.active,
        id: ctx.filter.id,
        plate: ctx.filter.plate,
        documentExpiration: ctx.filter.documentExpiration,
        typeName: ctx.filter.typeName,
        vehicleBrand: ctx.filter.vehicleBrand,
        vehicleModel: ctx.filter.vehicleModel,
      };
      this.$apiVehicle
        .post("/vehicleRegistratation/GetAll/", apiParam)
        .then((response) => {
          const items = response.data.items;
          // console.log = ("ok")
          // console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/getDropdown/").then((response) => {
        this.vehicleTypeOpt = response.data;
      });
    },
  },
};
</script>
<style scoped>
.alertMessage {
  color: #ffc600;
}
</style>
